export const CustomDe = {
  TITLE: "Code",
  BLOCKS: "Blocks",
  LINKTOOLTIP: "Speichern und mit Blöcken verknüpfen",
  RUNTOOLTIP:
    "Starte das Programm, das durch die Blöcke im Arbeitsbereich definiert ist",
  BADCODE: "Programmfehler:/n%1",
  TIMEOUT: "Maximale Anzahl an Ausführungsiterationen überschritten",
  TRASHTOOLTIP: "Alle Blöcke wegwerfen",
  CATLOGIC: "Logik",
  CATLOOPS: "Schleife",
  CATMATH: "Math",
  CATALGEBRA: "Algebra",
  CATANALYSIS: "Analyse",
  CATARITHMETIC: "Arithmetik",
  CATGEOMETRY: "Geometrie",
  CATMATRIX: "Matrizen",
  CATSTATS: "Stats",
  CATLANG: "Lang",
  CATFRENCH: "Französisch",
  CATTEXT: "Text",
  CATLISTS: "Liste",
  CATCOLOUR: "Farbe",
  CATVARIABLES: "Variable",
  CATFUNCTIONS: "Verfahren",
  CATMEDIA: "Medien",
  LISTVARIABLE: "Liste",
  TEXTVARIABLE: "Text",
  HTTPREQUESTERROR: "Es gab ein Problem mit dem Antrag",
  LINKALERT: "Teilen Sie Ihre Blöcke über diesen Link:c&H30D3F4&}",
  HASHERROR: "Sorry, '%1' entspricht keinem gespeicherten Programm",
  XMLERROR:
    "Die Sicherungsdatei konnte nicht geladen werden.  Vielleicht wurde sie mit einer anderen Version von Blockly erstellt?",
  BADXML:
    "Fehler beim Parsen von XML:🙁 Wählen Sie 'OK', um Ihre Änderungen zu verwerfen, oder 'Abbrechen', um die Bearbeitung des XML fortzusetzen.",
  CATEXAMPLES: "Einleitung",
  CATSTART: "Start",
  CATDISPLAY: "Anzeige",
  CATQUESTIONS: "Frage",
  CATAI: "IA",
  CATFEEDBACK: "Rückmeldungen",

  CATOBJECTS: "Objekte",
  //LABEL SEPARATORS
  LABEL_START: "Start",
  LABEL_FORMATTING: "Formatierung",
  LABEL_STYLES: "Styles",
  LABEL_EXPERT: "Experte",

  LABEL_NUMBERS: "Zahlen",
  LABEL_CALCULUS: "Berechnung",
  LABEL_ARITHMETICS: "Arithmetik",
  LABEL_FRACTIONS: "Brüche",
  LABEL_UNITS: "Einheiten",

  LABEL_FUNCTIONS: "Funktionen",
  LABEL_TOOLS: "Tools",
  LABEL_GRAPHIC: "Grafik",

  LABEL_OBJECTS: "Objekte",
  LABEL_TRANSFORMATIONS: "Transformations",
  LABEL_CALCULUSES: "Berechnungen",
  LABEL_DISPLAY: "Anzeige",

  LABEL_LIST_EXPERT: "Experte",
  LABEL_MATRIX_EXPERT: "Experte",

  //EXAMPLES CAT
  EXAMPLES_PRINCIPLE_TITLE: "Allgemeines Konstruktionsprinzip",
  EXAMPLES_PRINCIPLE_DOCUMENTATION: `Die Gestaltung einer Basisaktivität erfolgt mit 3 Hauptblöcken :
- 1: Ein Kopfblock am Anfang der Aktivität.
- 2: Ein Block Aussage darunter mit einem Block Poster, um Ihre Aussage anzuzeigen.
- 3: Ein oder mehrere Blöcke Fragen.
Die meisten Blöcke verfügen über Felder, die mit Standardblöcken oder -werten vorausgefüllt sind. Dies geschieht mit dem Ziel, Sie beim Aufbau Ihrer Aktivität zu leiten. Natürlich können diese Felder auch durch andere Arten von Blöcken ersetzt werden.`,

  //WORKSPACE
  DOWNLOAD_SCREENSHOT: "Screenshot hochladen",
  DELETE_UNUSED_VARIABLES: "Unbenutzte Variablen löschen",
  //START CAT
  //BLOCK INFO
  INFO_TITLE: "Aktivität",
  INFO_MESSAGE:
    "Aktivität Titel %1 Sprache %2 beschreibung %3 Versuche max%4 Standardrückmeldung%5",
  INFO_LANG_TOOLTIP: `Geben Sie den aus zwei Buchstaben bestehenden Sprachcode ein (Beispiele: "fr" für französisch, "en" für englisch ...).`,
  INFO_TOOLTIP: `Der Block Kopfzeile einer Aktivität. Er muss am Anfang der Aktivität platziert werden.
    - Titel: Hiermit können Sie den Titel der Aktivität.
    - Beschreibung: Kurze Beschreibung der Aktivität.
    - Standard-Feedback: entspricht einem automatischen, globalen Feedback für die Aktivität. Es ist vor allem dann nützlich, wenn die Aktivität mehrere Fragen einbindet. In diesem Fall zeigt das Feedback an, ob alle Fragen bestanden wurden oder ob mindestens eine der Fragen nicht bestanden wurde.`,
  INFO_COMMENT:
    "Kommentieren Sie hier, wie Ihr Code funktioniert, damit andere ihn verstehen und anpassen können.",
  //LANG
  LANG_MATRIX_TITLE: "Aktivität (Mehrsprachig)",
  LANG_MATRIX_DEFAULT_FEEDBACK: "Standardrückmeldung",
  LANG_MATRIX_MAX_ATTEMPTS: "Max Versuche",
  LANG_MATRIX_ACTIVITY_TITLE: "TITEL ",
  LANG_MATRIX_DESCRIPTION: "BESCHREIBUNG",
  LANG_MATRIX_LANG: "SPRACHE ",
  LANG_MATRIX_KEY: "KEY",
  LANG_MATRIX_DEFAULT_TEXT: "Text",
  LANG_MATRIX_CODE: "",
  LANG_MATRIX_TOOLTIP: `Tabelle, mit der Aktivitäten in mehreren Sprachen gestaltet werden können.
  Sie wird separat und über den anderen Blöcken im Gestaltungsbereich platziert, damit sie zuerst geladen wird.
  Jede Zeile enthält ein Schlüsselwort, gefolgt von seinen Übersetzungen in jeder Spalte.
  Jede Spalte entspricht einem Sprachcode. Die erste Spalte entspricht der Standardsprache.
  Eleda erkennt automatisch die Sprache des Browsers und zeigt das Wort oder den Satz an, der dem Schlüsselwort entspricht.
  `,

  //LANG_TEXT
  LANG_TEXT_TITLE: "Mehrsprachiger Text",
  LANG_TEXT_MESSAGE: "Text mit dem Schlüssel %1",
  LANG_TEXT_NOTFOUND: "ref nicht gefunden",
  LANG_TEXT_TOOLTIP:
    "Gibt die Zeichenkette zurück, die dem Schlüssel und der vom Browser eingestellten Sprache entspricht",

  //BLOCK STATEMENT
  STATEMENT_TITLE: "Erklärung",
  STATEMENT_MESSAGE: "Ausspruch %1",
  STATEMENT_TOOLTIP: `Contient l'ensemble des éléments à afficher dans l'énoncé.
    Contient le plus souvent des blocs "Affiche".`,
  //BLOCK DISPLAY_ELEMENT
  DISPLAY_ELEMENT_TITLE: "Anzeigen",
  DISPLAY_ELEMENT_MESSAGE: "anzeigen %1",
  DISPLAY_ELEMENT_LEFT_ALIGN: "linksbündig",
  DISPLAY_ELEMENT_CENTER_ALIGN: "zentriert",
  DISPLAY_ELEMENT_RIGHT_ALIGN: "rechtsbündig",
  DISPLAY_ELEMENT_JUSTIFY_ALIGN: "gerechtfertigt",
  DISPLAY_ELEMENT_TOOLTIP: `Ermöglicht die Anzeige von Elementen in einer "Erklärung".
    Meist im Block "Erklärung" enthalten.
    Enthält Blöcke aller Art: geometrische Figuren, Mathematik, Grafiken, Texte ...
    Wenn er geometrische Elemente enthält, wird er in einer Standardgrafik mit den Grenzen Xmin:0, Ymax:10, Xmax:10, Ymin:0 erstellt.
    Er ermöglicht es auch während der Entwurfsphase, die verschiedenen Werte und Variablen der Aktivität schnell zu überprüfen (Debugging).`,
  //PARAGRAPH (RICHTEXT)
  RICHTEXT_CREATE_WITH_TITLE: "Absatz",
  RICHTEXT_CREATE_WITH_INPUT_WITH: "einen Absatz erstellen mit ",
  RICHTEXT_CREATE_WITH_TOOLTIP: `Ermöglicht das Kombinieren von Objekten, um sie nacheinander in einem Absatz anzuzeigen.
    Gibt einen Absatz mit einer Reihe von Objekten zurück, die angezeigt werden sollen.
    Enthält meist einen Block "Anzeigen".
    Enthält meist Blöcke der Typen "Text", "LaTeX", "Markdown", "Geometrie", "Frage in verschachtelter Darstellung".`,

  //LATEX_PARAGRAPH (RICHTEXT)
  LATEX_PARAGRAPH_CREATE_WITH_TITLE: "LaTeX-Baugruppe",
  LATEX_PARAGRAPH_CREATE_WITH_INPUT_WITH: "einen LaTeX-Baugruppe erstellen mit",
  LATEX_PARAGRAPH_CREATE_WITH_TOOLTIP: `Ermöglicht es, LaTeX code mit Eleda-Blöcken zu kombinieren, um sie verschachtelt anzuzeigen.
    Gibt einen LaTeX-Baugruppe zurück, der zur Anzeige bereit ist.
    Enthält meist einen "Anzeige"-Block.
    Enthält meist Blöcke vom Typ "Text" (enthält LaTeX-Zeichenfolgen), "Frage in verschachtelter Anzeige", "Geometrie",.`,

  //ALIGNMENT  COLOUR RANDOM_COLOUR SIZE
  SET_ALIGNMENT_TOOLTIP:
    "Richtet den enthaltenen Block links, mittig oder rechts aus. Enthält meist einen Absatzblock",
  SET_COLOUR_TOOLTIP:
    "Wendet eine Farbe auf einen Block an. Dieser Block kann auf viele verschiedene Blöcke (Text, Geometrie etc.) angewendet werden.",
  SET_COLOUR_RANDOM_TOOLTIP:
    "Wendet eine zufällige Farbe auf einen Block an. Dieser Block kann auf viele verschiedene Blöcke (Text, Geometrie etc.) angewendet werden.",
  SET_SIZE_TOOLTIP:
    "Wendet eine Größe auf einen Block an. Dieser Block kann auf viele verschiedene Blöcke angewendet werden (Text, Frage, Geometrie usw.).",
  SET_ATTRIBUTE_MESSAGE: "parametrisieren %1 mit %2 ",
  SET_ATTRIBUTE_TOOLTIP:
    "Erweitert: Wendet eine oder mehrere bestimmte Einstellungen auf ein Objekt an und folgt dabei dem JSON-Format.",
  SET_ATTRIBUTE_DOCUMENTATION: `Erweitert: Dieser Block kann verschiedene Arten von Blöcken enthalten und ihnen bestimmte Eigenschaften im JSON-Format zuweisen.
    Dieser Block kann die folgenden Blöcke enthalten und die folgenden Parameter auf sie anwenden:
    - Mathematische Blöcke (algebraischer Ausdruck ...):
    • 'smartDisplay' : standardmäßig "true". Versuchen Sie, einen mathematischen Ausdruck so gut wie möglich zu vereinfachen und umzuformen.  
    - Geometrieblöcke (Polygone, Kreise ...): 
    • 'fillColor', um eine Figur mit einer Farbe zu füllen, die durch ihren Hexadezimalcode (zum Beispiel '#ff0000') oder durch 'random' bestimmt wird
    • 'dash', um ein gestricheltes Muster zu setzen. Der Wert muss zwischen 0 und 6 liegen (0: durchgezogene Linie, 1: gepunktete Linie, 3: Linie mit normalen Strichen ...)
    • 'group', um die Punkte eines Polygons zu gruppieren, was eine vollständige Translation des Polygons durch Verschieben eines seiner Eckpunkte ermöglicht.
    - Datentabellenblock : 'isBordered' (standardmäßig true) erlaubt es, die Zellenränder anzuzeigen oder nicht, 'isStriped' (standardmäßig true) erlaubt es, jede zweite Zeile grau zu machen, 'isHoverable' (standardmäßig false) erlaubt es, die Zeilen zu beleuchten, wenn die Maus darüber fährt
    `,

  //BLOCK MARKDOWN
  MARKDOWN_TITLE: "markdown",
  MARKDOWN_MESSAGE: "markdown %1",
  MARKDOWN_TOOLTIP: `Ermöglicht die Verwendung der Markdown-Notation.
    Gibt ein HTML-Objekt zurück, das angezeigt werden soll.
    Meist in einem "Zeige"-Block enthalten.
    Enthält nur Blöcke vom Typ "Text" und interpretiert Markdown-Zeichen.

    - Beispiele: Eine Zeile mit # beginnen, um eine Überschrift der Ebene 1 anzuzeigen, mit ## für eine Überschrift der Ebene 2, ein Wort mit zwei ** umschließen, um es fett zu markieren ...
`,
  //BLOCK LATEX
  LATEX_TITLE: "LaTeX",
  LATEX_MESSAGE: "LaTeX %1",
  LATEX_TOOLTIP: `Ermöglicht die Verwendung der LaTeX-Notation.
    Gibt ein HTML-Objekt zurück, das angezeigt werden soll.
    Meist in einem "Anzeige"-Block enthalten.
    Enthält nur Blöcke vom Typ "Text" und interpretiert die LaTeX-Notation.  LaTeX ist eine sehr mächtige Sprache, mit der sich wissenschaftliche Texte und Formeln auf elegante Weise darstellen lassen. Ausdrücken muss ein "\\" vorangestellt werden.
    Weitere Informationen: Lesen Sie die Dokumentation`,

  LATEX_DOCUMENTATION: `Ermöglicht die Verwendung der LaTeX-Notation.
    Gibt ein HTML-Objekt zurück, das angezeigt werden soll.
    Meist in einem "Anzeige"-Block enthalten.
    Enthält nur Blöcke vom Typ "Text" und interpretiert die LaTeX-Notation.  LaTeX ist eine sehr mächtige Sprache, mit der sich wissenschaftliche Texte und Formeln auf elegante Weise darstellen lassen. Den Ausdrücken muss ein "\\" vorangestellt werden.
    
    - Beispiel 1 : \\dfrac{ax+b}{b} in einem "LaTeX"-Block, der in einem "Zeige"-Block enthalten ist, zeigt einen Bruch an.
    - Beispiel 2 : \\textrm{L'élément } u_2 \\textrm{ ist das zweite Element der Folge } u_n zum Mischen von lateinischem Text und Mathematik
    - Beispiel 3 : f(n)=\\begin{cases} n/2, & \\mbox{si }n\\mbox{ ist gerade} \\\\ 3n+1, & \\mbox{si }n\\mbox{ Wertminderung} \\end{cases}`,
  //BLOCK SPECIAL_CHARACTER
  SPECIAL_CHARACTER_TOOLTIP:
    "Führt einen Zeilenumbruch durch oder fügt ein horizontales Linientrennzeichen ein",

  //BLOCK VERSION
  VERSION_MESSAGE: "Erstellen Sie die Versionen der Aktivität mit",
  VERSION_DEFAULTVERSION: "Standardversion",
  VERSION_VERSIONN: "Version Nr.",
  VERSION_LABEL: " mit dem Label",
  VERSION_TOOLTIP: "Ermöglicht die Erstellung einer Multi-Version-Aktivität.",

  CLEAN_ACTIVITY_MESSAGE: "Lösche alle Inhalte der Aktivität (beta)",
  CLEAN_ACTIVITY_TOOLTIP:
    "Löscht den gesamten Inhalt einer Aktivität. Wird oft in einem Feedback verwendet, um die Historie vorheriger Aussagen, Fragen und Feedbacks zu löschen und neue Informationen anzuzeigen",

  //BLOCK QUESTIONS
  //COMMON STRINGS CONTAINED IN QUESTION BLOCKS
  QUESTION_WARNING_NESTED_QUESTIONS:
    "Achtung: Um Fragen zu verschachteln, muss im Kopfblock zwingend der Wert 'tentatives max' auf 1 gesetzt werden.",
  QUESTION_GENERAL_MORE_OPTIONS_NB_PROPOSALS:
    "Anzahl der anzuzeigenden Vorschläge",
  QUESTION_GENERAL_MORE_OPTIONS_DEFAULT_FEEDBACKS: "Standardrückmeldung",
  QUESTION_GENERAL_MORE_OPTIONS_DISPLAY: "Anzeige",
  QUESTION_GENERAL_MORE_OPTIONS_DISPLAY_EXTERNAL: "extern",
  QUESTION_GENERAL_MORE_OPTIONS_DISPLAY_INLINE: "verschachtelt",
  QUESTION_GENERAL_MORE_OPTIONS_LEARNERANSWER_SAVEIN:
    "Antwort des Lernenden gespeichert in",
  QUESTION_GENERAL_MORE_OPTIONS_LEARNERANSWER_SAVEIN_NAMEVAR: "Antwort",
  QUESTION_GENERAL_MORE_OPTIONS_QUESTION_SAVEIN: "Frage gespeichert in",
  QUESTION_GENERAL_MORE_OPTIONS_QUESTION_SAVEIN_NAMEVAR: "Frage",
  QUESTION_GENERAL_MORE_OPTIONS_FEEDBACKS: "⏎ Rückmeldungen",
  //BLOCK QUESTION_TRUE_FALSE
  QUESTION_TRUE_FALSE_TRUE: "richtig",
  QUESTION_TRUE_FALSE_FALSE: "falsch",
  QUESTION_TRUE_FALSE_TITLE: "Frage: mit richtig oder falsch beantworten",

  QUESTION_TRUE_FALSE_MESSAGE:
    "❓ Frage Richtig/Falsch %1 Text %2 ✅ Richtige Antwort %3 %4 Erweiterte Optionen",
  QUESTION_TRUE_FALSE_TOOLTIP: `Aufforderung, einen Vorschlag zu bestätigen oder zu widerlegen.
    - Text: Er enthält den Text der Aussage oder eine Anweisung.
    - Richtige Antwort: Wahr oder falsch. Sie kann direkt das logische Element wahr oder falsch sein oder das Ergebnis eines komplexeren logischen Tests enthalten.
    Weitere Informationen: Lesen Sie die Dokumentation.`,

  QUESTION_TRUE_FALSE_DOCUMENTATION: `Aufforderung, einen Vorschlag zu bestätigen oder zu widerlegen.
   - Text: Er enthält den Text der Aussage oder eine Anweisung.
   - Richtige Antwort: Wahr oder falsch. Sie kann direkt das logische Element wahr oder falsch sein oder das Ergebnis eines komplexeren logischen Tests enthalten.
  
    Erweiterte Optionen :
    - Anzeige: Mit der Option "extern" wird die Frage nach der Aussage angezeigt; mit der Option "verschachtelt" wird die Frage innerhalb der Aussage angezeigt.
    - Antwort gespeichert in: Hier können Sie die Variable auswählen, die die Antwort des Lernenden auf einen Boolean (wahr oder falsch) speichert.
    - Standard-Feedback: Hier können Sie festlegen, ob die Standardmeldung über das Bestehen oder Nichtbestehen der Frage angezeigt werden soll.
    - Feedback: Enthält Blöcke "Feedback (feedback)", die es ermöglichen, Feedback in Bezug auf diese Frage und abhängig von der Antwort des Lernenden auszulösen.
    
    Rohe Optionen (JSON) enthält spezifische Parameter, die im JSON-Format bereitgestellt werden sollen :
    - feedbackcolor (boolean) : Standardmäßig "true". Wenn "false", wird der Antwortbereich des Lernenden nicht mehr entsprechend seiner Antwort gefärbt.
    - grade (boolean) : Standardmäßig "true". Wenn "false", wird der Block "Define grade manually" die Note des Lernenden festlegen, wenn eine Sequenz abgeschlossen ist.
    `,

  //BLOCK MULTIPLE_CHOICES_QUESTION
  QUESTION_MULTIPLE_CHOICES_TITLE: "Multiple-Choice-Frage",

  QUESTION_MULTIPLE_CHOICES_MESSAGE:
    "❓ Multiple-Choice-Frage %1 Typ %2 %3 Text %4 ✅ richtige Antwort(en) %5 ❌ falsche Antwort(en) %6 %7 erweiterte optionen",

  QUESTION_MULTIPLE_CHOICES_MULTIPLE: "mehrere richtige Antworten",
  QUESTION_MULTIPLE_CHOICES_UNIQUE: "nur eine richtige Antwort",

  QUESTION_MULTIPLE_CHOICES_TOOLTIP: `Fordert Sie auf, eine oder mehrere Antworten aus einer Reihe von Vorschlägen auszuwählen.
    - Typ: Hier können Sie festlegen, ob es sich um eine Single-Choice- oder Multiple-Choice-Frage handelt.
    - Text: Enthält den Text der Aussage oder eine Anweisung.
    - Richtige Antworten: Liste der Antworten, die als richtig angesehen werden.
    - Falsche Antworten: Liste der als falsch eingestuften Antworten.
    Weitere Informationen: Lesen Sie die Dokumentation.`,

  QUESTION_MULTIPLE_CHOICES_DOCUMENTATION: `Fordert Sie auf, eine oder mehrere Antworten aus einer Reihe von Vorschlägen auszuwählen.
    - Typ: Hier können Sie festlegen, ob es sich um eine Single-Choice-Frage (nur eine mögliche Antwort aus einer Reihe von Aussagen) oder eine Multiple-Choice-Frage (mehrere mögliche Antworten aus einer Reihe von Aussagen) handelt.
    - Text: Enthält den Text der Aussage oder eine Anweisung.
    - Richtige Antworten: Liste der als richtig erachteten Antworten (bei einer Multiple Choice-Frage ist die Liste entweder eine Liste, die nur ein Element enthält, oder nur ein Element).
    - Falsche Antworten: Liste der als falsch eingestuften Antworten.

    Erweiterte Optionen :
    - Anzahl der anzuzeigenden Vorschläge : Leer lassen, um alle Möglichkeiten (richtig und falsch) anzuzeigen. Falls angegeben: Ermöglicht die zufällige Auswahl einer begrenzten Anzahl von Vorschlägen, die dem Lernenden aus der Gesamtheit der richtigen und falschen Antworten präsentiert werden. In einer Single-Choice-Frage wird immer die richtige Antwort vorgeschlagen. Bei einer Multiple-Choice-Frage kann es vorkommen, dass nur falsche Antworten angeboten werden; in diesem Fall darf der Lernende nichts ankreuzen, um richtig zu liegen.
    - Anzeige: Mit der Option "extern" wird die Frage nach der Aussage angezeigt; mit der Option "verschachtelt" wird die Frage innerhalb einer Aussage angezeigt.
    - Antwort gespeichert in: Hier können Sie die Variable auswählen, die die Antwort des Lernenden speichert. Die Variable wird die Liste der vom Lernenden angekreuzten Elemente enthalten.
    - Standard-Feedback: Hier können Sie festlegen, ob die Standardmeldung über das Bestehen oder Nichtbestehen der Frage angezeigt werden soll.
    - Feedback: Enthält Blöcke "Feedback (feedback)", mit denen Sie Rückmeldungen in Bezug auf diese Frage und je nach Antwort des Lernenden auslösen können.
    
    Rohe Optionen (JSON) enthält spezifische Parameter, die im JSON-Format bereitgestellt werden sollen :
    - feedbackcolor (boolean) : Standardmäßig "true". Wenn "false", wird der Antwortbereich des Lernenden nicht mehr entsprechend seiner Antwort gefärbt.
    - grade (boolean) : Standardmäßig "true". Wenn "false", wird der Block "Define grade manually" die Note des Lernenden festlegen, wenn eine Sequenz abgeschlossen ist.
    `,

  //BLOCK QUESTION_OPEN
  //=> ajouter var glob pour les inputs
  QUESTION_OPEN_TYPE_INTEGER_POSITIVE: "positive ganze Zahl",
  QUESTION_OPEN_TYPE_INTEGER: "ganz",
  QUESTION_OPEN_TYPE_DECIMAL: "dezimal",
  QUESTION_OPEN_TYPE_FRACTION: "Fraktion",
  QUESTION_OPEN_TYPE_TEXT: "Text",
  QUESTION_OPEN_TYPE_EXPRESSION: "mathematischer Ausdruck",
  QUESTION_OPEN_TYPE_LIST: "Liste oder Matrix (bald verfügbar)",
  QUESTION_OPEN_OPTION_CASE_SENSITIVE: "Groß- und Kleinschreibung beachten",
  QUESTION_OPEN_OPTION_TITLE: "rohe Optionen (JSON)",

  QUESTION_OPEN_TITLE: "Offene Frage",

  QUESTION_OPEN_MESSAGE:
    "❓ Offene Frage %1 Text %2 Art der erwarteten Antwort %3 %4 ✅ Richtige Antwort %5 %6 Erweiterte Optionen",
  QUESTION_OPEN_TOOLTIP: `Aufforderung, einen Wert einer bestimmten Art anzugeben.
    - Text: Er enthält den Text des Vorschlags oder eine Anweisung.  
    - Typ der erwarteten Antwort: Entspricht dem Typ des erwarteten Wertes.
    - Richtige Antwort: Der Wert, der der richtigen Antwort entspricht. Er kann direkt der Wert oder eine Variable sein oder das Ergebnis einer komplexeren Berechnung enthalten.
    Weitere Informationen: Lesen Sie die Dokumentation.`,

  QUESTION_OPEN_DOCUMENTATION: `Aufforderung, einen Wert einer bestimmten Art anzugeben.
    - Text: Enthält den Text der Aussage oder eine Anweisung.
    - Typ der erwarteten Antwort: entspricht dem Typ des erwarteten Wertes.
    - Text: Die erwartete Antwort ist ein Text. Um als richtig zu gelten, muss die gegebene Antwort genau wie die richtige Antwort eingegeben werden (unter Beachtung von Groß- und Kleinschreibung, Akzenten...). Feinere Einstellungen werden in Kürze implementiert, um Groß- und Kleinschreibung, Akzente, überflüssige Leerzeichen, Rechtschreibfehler usw. zu berücksichtigen oder nicht zu berücksichtigen.
    - Ganz oder positive ganze Zahl: Die erwartete Antwort ist eine ganze Zahl; der numerische Wert (Integer), der der richtigen Antwort entspricht. Er kann direkt der Wert sein, eine Variable oder das Ergebnis einer komplexeren Berechnung enthalten.
    - Dezimal: Die erwartete Antwort ist eine Dezimalzahl. Um als richtig zu gelten, darf die Antwort nicht gerundet werden. Feinere Einstellungen werden in Kürze implementiert, um die Genauigkeit (Anzahl der signifikanten Stellen) zu berücksichtigen...
    - Bruch: Die erwartete Antwort ist ein Bruch. Um als richtig zu gelten, muss die Antwort als nicht reduzierbarer Bruch eingegeben werden.
    - Ausdruck: Die erwartete Antwort ist ein symbolischer Ausdruck (z. B.: 3x+2). Um als richtig zu gelten, muss die eingegebene Antwort äquivalent sein (z. B. 2+3*x).
    - Liste oder Matrix: Die erwartete Antwort ist eine Liste oder eine Matrix, die in der Form [[1,2],[3,4]] eingegeben wird.
    - Richtige Antwort: Der Wert, der der richtigen Antwort entspricht. Er kann direkt der Wert sein, eine Variable oder das Ergebnis einer komplexeren Berechnung enthalten.

    Erweiterte Optionen :
    - Anzeige: Mit der Option "extern" wird die Frage nach der Aussage angezeigt; mit der Option "verschachtelt" wird die Frage innerhalb der Aussage angezeigt.
    - Antwort gespeichert in: Hier können Sie die Variable auswählen, die die vom Lernenden eingegebene Antwort speichert.
    - Standard-Feedback: Ermöglicht es, die Anzeige der Standardmeldung über das Bestehen oder Nichtbestehen der Frage zu aktivieren oder zu deaktivieren.
    - Feedback: Enthält Blöcke "Feedback (feedback)", die es ermöglichen, Rückmeldungen in Bezug auf diese Frage und je nach Antwort des Lernenden auszulösen.
    
    Rohe Optionen (JSON) enthält spezifische Parameter, die im JSON-Format bereitgestellt werden sollen :
    
    - Für alle Arten von erwarteten Antworten :
    • feedbackcolor (boolean) : Standardmäßig "true". Wenn "false", wird der Antwortbereich des Lernenden nicht mehr entsprechend seiner Antwort gefärbt.
    • grade (boolean) : Standardmäßig "true". Wenn "false", wird der Block "Define grade manually" die Note des Lernenden festlegen, wenn eine Sequenz abgeschlossen ist.
    • emptyMeansZero (boolean) : "false" als Standard. Bei "true" wird eine leer gelassene Antwort als Wert 0 betrachtet.
    • callbackSolution (boolean) : "false" ist die Standardeinstellung. Wenn "true", ist die richtige Antwort eine Prozedur, die anstelle eines Wertes ein Boolean zurückgibt. Diese Prozedur gibt "true" oder "false" zurück, je nachdem, wie Sie die Antwort des Lernenden analysieren.
    • length (number) : Diese Option ist nur bei verschachtelten offenen Fragen wirksam. 10 Standardmäßig entspricht sie ungefähr der Anzahl der Zeichen, die im Eingabefeld angezeigt werden können.
    
    - Für die erwarteten Antworttypen Text, Integer und Decimal: 
    • maxLength (number) : Diese Option ist nur bei verschachtelten offenen Fragen wirksam. Sie schränkt die Anzahl der Zeichen ein, die der Lernende in das Eingabefeld eingeben kann.
    
    - Für den Typ Text :
    • caseSensitive (boolean) : "false" ist die Standardeinstellung. Wenn "true", muss die Antwort die Groß-/Kleinschreibung beachten, um als richtig zu gelten.
    • spaceSensitive (boolean) :  "false" als Standard festgelegt. Wenn "true", darf die Antwort keine überflüssigen Leerzeichen enthalten, um als richtig zu gelten.
    
    - Für den Typ Dezimal :
    • precision (integer) : définit à combien de chiffres significatifs doit être arrondi la réponse pour être considérée comme juste.
    
    - Für den Typ Fraktion : 
    • irreducibleFraction (boolean) : "false" als Standard. Wenn "true", muss die Antwort irreduzibel sein, um als richtig zu gelten.
    
    Beispiel, wenn der Typ Text gewählt wurde :
    { "caseSensitive" : true, "spaceSensitive" : true}
    wird verwendet, um anzugeben, dass die Antwort als richtig angesehen wird, wenn sie die Groß- und Kleinschreibung beachtet und keine überflüssigen Leerzeichen enthält.
    `,

  //BLOCK QUESTION_REORDER
  QUESTION_REORDER_TITLE: "Frage: Elemente anordnen",
  QUESTION_REORDER_TEXT: "Ordne die Elemente",
  QUESTION_REORDER_MESSAGE:
    "❓ Frage Ordnen %1 Text %2 ✅ Zu ordnende Liste %3 %4 Erweiterte Optionen",
  QUESTION_REORDER_TOOLTIP: `Fordert dazu auf, Elemente miteinander zu ordnen.
    - Zu ordnende Liste : Die Liste der korrekt geordneten Elemente.
    Weitere Informationen: Lesen Sie die Dokumentation.`,

  QUESTION_REORDER_DOCUMENTATION: `Fordert dazu auf, Elemente miteinander zu ordnen.
    - Zu ordnende Liste : Die Liste der korrekt geordneten Elemente.
  
    Erweiterte Optionen :
    - Anzahl der anzuzeigenden Vorschläge : Leer lassen, um alle Elemente der zu ordnenden Liste anzuzeigen. Falls angegeben: Ermöglicht die zufällige Auswahl einer begrenzten Anzahl von Vorschlägen, die dem Lernenden präsentiert werden.
    - Antwort gespeichert in: Ermöglicht die Auswahl der Variablen, die die Antwort des Lernenden speichern wird. Die Variable enthält eine Liste der Elemente mit korrekten Positionen. Durch Abzug werden die falsch positionierten Elemente gefunden.
    - Standard-Feedback: Hier können Sie festlegen, ob die Standardmeldung über das Bestehen oder Nichtbestehen der Frage angezeigt werden soll.
    - Feedback: Enthält Blöcke "Feedback (feedback)", die es ermöglichen, Feedback in Bezug auf diese Frage und abhängig von der Antwort des Lernenden auszulösen.
  
    Rohe Optionen (JSON) enthält spezifische Parameter, die im JSON-Format bereitgestellt werden sollen :
    - grade (boolean) : Standardmäßig "true". Wenn "false", wird der Block "Define grade manually" die Note des Lernenden festlegen, wenn eine Sequenz abgeschlossen ist.
    `,

  //BLOCK QUESTION_ASSOCIATE
  QUESTION_ASSOCIATE_TITLE: "Frage: Elemente verknüpfen",
  QUESTION_ASSOCIATE_TEXT: "Assoziieren Sie die Elemente",
  QUESTION_ASSOCIATE_MESSAGE:
    "❓ Frage Zuordnen %1 Text %2 ✅ Liste von Elementen %3 ✅ Liste von Merkmalen %4 %5 Erweiterte Optionen",
  QUESTION_ASSOCIATE_TOOLTIP: `Fordert dazu auf, Elemente mit ihrem Merkmal zu verbinden. Jedes Element muss ein eindeutiges Merkmal haben.
    - Elemente: Die Liste der Elemente.
    - Merkmale: Die Liste der Merkmale der entsprechenden Elemente.
    Das Element mit dem Index 'i' aus der Liste der Elemente hat das Merkmal mit dem Index 'i' aus der Liste der Merkmale.
    Weitere Informationen: Lesen Sie die Dokumentation.
    `,

  QUESTION_ASSOCIATE_DOCUMENTATION: `Fordert dazu auf, Elemente mit ihrem Merkmal zu verbinden. Jedes Element muss ein eindeutiges Merkmal haben.
    - Elemente: Die Liste der Elemente.
    - Merkmale: Die Liste der Merkmale der entsprechenden Elemente.
    Das Element mit dem Index 'i' aus der Liste der Elemente hat das Merkmal mit dem Index 'i' aus der Liste der Merkmale.
  
    Erweiterte Optionen :
    - Speichert die Antwort des Lernenden in: Hiermit können Sie die Variable auswählen, die die Antwort des Lernenden speichern wird. Die Variable wird die Liste der Elemente enthalten, die korrekt mit ihrem Merkmal verknüpft sind,
    - Anzahl der anzuzeigenden Vorschläge : Leer lassen, um alle Elemente und ihre Merkmale anzuzeigen. Falls angegeben, erlaubt es, eine begrenzte Anzahl von Elementen mit ihrem Merkmal zufällig auszuwählen.
    - Standard-Feedback: Ermöglicht es, die Anzeige der Standardmeldung über das Bestehen oder Nichtbestehen der Frage zu aktivieren oder zu deaktivieren.
    - Feedback: Enthält Blöcke "Feedback (Rückmeldungen)", mit denen Rückmeldungen in Bezug auf diese Frage und abhängig von der Antwort des Lernenden ausgelöst werden können.
    
    Rohe Optionen (JSON) enthält spezifische Parameter, die im JSON-Format bereitgestellt werden sollen :
    - grade (boolean) : Standardmäßig "true". Wenn "false", wird der Block "Define grade manually" die Note des Lernenden festlegen, wenn eine Sequenz abgeschlossen ist.
    `,

  //BLOC QUESTION_FIGURE
  QUESTION_FIGURE_TITLE: "Frage zu einem Diagramm",
  QUESTION_FIGURE_MESSAGE:
    "❓ Frage zu einer Grafik %1 betroffene Grafik %2 %3 ✅ Bedingung richtige Antwort %4 %5 erweiterte optionen",
  QUESTION_FIGURE_TOOLTIP: `Aufforderung, mit einem Graphen zu interagieren (Punkte verschieben, eine Figur konstruieren ...).
    - Betroffene Grafik: Variable, in der die Grafik gespeichert ist.
    - Bedingung richtige Antwort: Boolean Ergebnis eines Tests (z. B. Testen der Koordinaten eines Punktes).
    `,

  QUESTION_FIGURE_DOCUMENTATION: `Aufforderung, mit einem Graphen zu interagieren (Punkte verschieben, eine Figur konstruieren ...).
    - Betroffene Grafik: Variable, in der die Grafik gespeichert ist.
    - Bedingung richtige Antwort: Boolean Ergebnis eines Tests (z. B. Testen der Koordinaten eines Punktes).
    
    Rohe Optionen (JSON) enthält spezifische Parameter, die im JSON-Format bereitgestellt werden sollen :
    - grade (boolean) : Standardmäßig "true". Wenn "false", wird der Block "Define grade manually" die Note des Lernenden festlegen, wenn eine Sequenz abgeschlossen ist.
    `,

  //CATEGORY FEEDBACK
  //BLOCK FEEDBACK_MESSAGE_TYPE
  FEEDBACK_MESSAGE_TYPE_MESSAGE:
    "Stellen Sie den Ton der Feedback-Meldungen auf %1",
  FEEDBACK_MESSAGE_TYPE_KIDS: "Kinder/Jugendliche",
  FEEDBACK_MESSAGE_TYPE_NEUTRAL: "Neutral",
  FEEDBACK_MESSAGE_TYPE_FORMAL: "Formell",
  FEEDBACK_MESSAGE_TYPE_TOOLTIP: `Wählen Sie den Ton aus, der für die anzuzeigenden Feedback-Meldungen verwendet wird. 
  Der Ton der Feedback-Meldungen kann neutral, kinder-/jugendorientiert oder erwachsenenorientiert (formell) sein. 
  Standardmäßig ist der Ton der Feedback-Meldungen neutral.`,

  //BLOCK FEEDBACK
  FEEDBACK_TITLE: "Rückkopplung",
  FEEDBACK_MESSAGE: "⏎ Feedback (deprecated) %1 if %2 zeigt %3",
  FEEDBACK_TOOLTIP: `Ermöglicht die Anzeige von Nachrichten auf der Grundlage von logischen Tests.
    - si: entspricht dem logischen Test, der die Anzeige des Textes auslöst. Meistens wird der logische Test an der Variablen durchgeführt, die die Antwort des Lernenden speichert.
    - anzeigt: Der Text, der angezeigt werden soll, wenn der Test wahr ist. Jedes anzeigbare Element kann ausgewählt werden (Texte, Grafiken ...).`,

  FEEDBACK_LOCAL_TITLE: "Beispiel",
  //PSEUDO FEEDBACK BLOCKS
  FEEDBACK_GLOBAL_EXAMPLE_DOCUMENTATION: `Dieses Set ist ein vorgefertigtes Beispiel, das am Ende einer Aktivität integriert werden kann.
Je nach den Antworten der Lernenden auf die Fragen wird eine personalisierte Nachricht angezeigt.`,
  FEEDBACK_TEST_ATTEMPTS_DOCUMENTATION: `Dieser Satz ist ein vorkonstruiertes Beispiel, das in die erweiterten Optionen eines Frageblocks oder des globalen Feedbackblocks integriert werden kann.
    Er bietet eine einfache Möglichkeit, den aktuellen Versuch des Lernenden oder die verbleibenden Versuche des Lernenden zu testen. Auf diese Weise können Sie ein progressives Feedback entwerfen, das die Anzahl der verbrauchten Versuche berücksichtigt.`,

  //BLOCK FEEDBACK GLOBAL
  FEEDBACK_GLOBAL_TITLE: "globale Rückkopplungen",
  FEEDBACK_GLOBAL_MESSAGE: "globale Rückmeldungen %1",
  FEEDBACK_GLOBAL_TOOLTIP:
    "Enthält Blöcke, mit denen Rückmeldungen in Bezug auf diese Aktivität und alle diese Fragen ausgelöst werden können. Meistens sind die globalen Rückmeldungen von den Antworten der Lernenden abhängig",

  //BLOCK ISSOLUTIONFOUND
  FEEDBACK_IS_SOLUTION_FOUND: "Lösung für diese Frage wurde gefunden",
  FEEDBACK_ARE_ALL_SOLUTIONS_FOUND: "Alle Lösungen für Fragen werden gefunden",
  FEEDBACK_IS_SOLUTION_FOUND_TOOLTIP: `muss innerhalb der Rückmeldungen einer Frage oder des globalen Rückmeldungsblocks verwendet werden.
  - Lösung für diese Frage gefunden: Gibt wahr zurück, wenn die Lösung der Frage gefunden wurde.
  - Alle Lösungen der Fragen in der Aktivität gefunden: Gibt wahr zurück, dass alle Lösungen der Fragen in der Aktivität gefunden wurden.
     `,

  //BLOCK CURRENT_ATTEMPT
  FEEDBACK_CURRENT_ATTEMPT_MESSAGE: "Versuch des Lernenden im Unterricht",
  FEEDBACK_CURRENT_ATTEMPT_TOOLTIP: `muss innerhalb der Rückmeldungen einer Frage oder des Blocks Globale Rückmeldungen verwendet werden.
  - Gibt eine ganze Zahl zurück, die der Nummer des aktuellen Versuchs des Lernenden entspricht.`,

  //BLOCK MAX_ATTEMPTS
  FEEDBACK_MAX_ATTEMPTS_MESSAGE: "maximale Versuche der Aktivität",
  FEEDBACK_MAX_ATTEMPTS_TOOLTIP: `muss innerhalb der Rückmeldungen einer Frage oder des globalen Rückmeldungsblocks verwendet werden.
  - Gibt eine ganze Zahl zurück, die der maximalen Anzahl an Versuchen entspricht, die in der Aktivität definiert ist.`,

  //BLOCK MESSAGE
  FEEDBACK_MESSAGE_TOOLTIP: "Gibt eine Standardrückmeldung zurück.",
  FEEDBACK_MESSAGE_MESSAGE: "meldung",
  FEEDBACK_MESSAGE_SOLUTION_FOUND_ATFIRSTATTEMPT: "Lösung auf Anhieb gefunden",
  FEEDBACK_MESSAGE_SOLUTION_FOUND: "Lösung gefunden",
  FEEDBACK_MESSAGE_SOLUTION_NOTFOUND_BUTREMAININGATTEMPTS:
    "Lösung nicht gefunden, aber weitere Versuche",
  FEEDBACK_MESSAGE_SOLUTION_NOTFOUND: "Lösung nicht gefunden",

  CONTEXT_QUESTION_MESSAGE: "Im Kontext der Frage %1 %2 %3",
  CONTEXT_QUESTION_TOOLTIP:
    "Ermöglicht es Ihnen, im Kontext einer Frage zu arbeiten. Nützlich, um in einer Prozedur das Feedback einer Frage zu externalisieren.",

  SET_GRADE_MESSAGE:
    "Beenden Sie die Aktivität und setzen Sie die Punktzahl auf %1%",
  SET_GRADE_TOOLTIP:
    "Dieser Block setzt manuell eine Notiz für die Aktivität und beendet die Aktivität. Diese Note wird in die Statistik einer Sequenz aufgenommen und ersetzt die Standardnote.",

  SET_ANALYTIC_MESSAGE:
    "Speichern eines Learning Analytic mit dem Schlüssel %1 und dem Wert %2",
  SET_ANALYTIC_TOOLTIP:
    "In diesem Block können Sie einen Tracking-Indikator (learning analytic) speichern, der durch einen Schlüssel und einen Wert definiert ist. Mit diesem Analytic können Werte während der Ausführung der Aktivität durch einen Lernenden aufgezeichnet werden. Der Wert des Analytikers kann dann über die Statistiken einer Sequenz abgerufen werden.",

  //BLOCK IA
  IA_TITLE: "IA",
  IA_MESSAGE: "IA (in Kürze...) %1",
  IA_TOOLTIP:
    "Funktionen der Künstlichen Intelligenz werden in Kürze implementiert",

  //MATH ARITHMETIC
  //RANDOM_NUMBER
  RANDOM_NUMBER_MESSAGE: "🎲 %1 zufällig zwischen%2 und%3",
  RANDOM_NUMBER_INTEGER: "ganz",
  RANDOM_NUMBER_DECIMAL: "dezimal",
  RANDOM_NUMBER_TOOLTIP:
    "Gibt eine Zufallszahl (ganze Zahl oder Dezimalzahl) zurück, die größer oder gleich dem Minimum und strikt kleiner als das Maximum ist, gemäß einer Gleichverteilung",
  //BLOCK ROUND_DECIMAL
  ROUND_DECIMAL_MESSAGE: "von %1 auf %2 Dezimalstellen gerundet",
  ROUND_DECIMAL_TOOLTIP:
    "Gibt die Rundung einer Zahl mit n Dezimalstellen zurück.",

  //BLOCK INTEGER_DECIMAL_PART
  INTEGER_DECIMAL_PART_MESSAGE: "%1 %2",
  INTEGER_DECIMAL_PART_INTEGER: "ganzer Teil",
  INTEGER_DECIMAL_PART_DECIMAL: "Dezimalteil",
  INTEGER_DECIMAL_PART_TOOLTIP:
    "Gibt den ganzzahligen oder dezimalen Teil einer Zahl zurück.",

  //BLOCK SPLIT_NUMBER
  SPLIT_NUMBER_MESSAGE: "zerlegt die Zahl %1 in Ziffern",
  SPLIT_NUMBER_TOOLTIP:
    "Gibt die Liste der Ziffern zurück, aus denen eine Zahl besteht",

  //BLOCK INTEGER_PART
  INTEGER_PART_MESSAGE: "ganzzahliger Teil von %1",
  INTEGER_PART_TOOLTIP: "Gibt den ganzzahligen Teil einer Zahl zurück",

  //BLOCK DECIMAL_PART
  DECIMAL_PART_MESSAGE: "dezimaler Teil von %1",
  DECIMAL_PART_TOOLTIP: "Gibt den dezimalen Teil einer Zahl zurück.",

  //BLOCK GCD_LCM
  GCD_LCM_OPERATOR_GCD: "PGCD",
  GCD_LCM_OPERATOR_LCM: "PCCM",
  GCD_LCM_MESSAGE: "%1 aus der Liste %2",
  GCD_LCM_TOOLTIP: "Gibt die PGCD oder PPCM aller Zahlen in der Liste zurück.",

  /////////////////////
  //MATH GEOMETRY
  BOARD_TITLE: "Grafik",
  BOARD_GEOMETRIC_MESSAGE:
    "📈 Grafik Xmin%1 Xmax%2 Ymin%3 Ymax%4 ⊞%5 %6 %7▦ %8 %9🕹",
  BOARD_SIZE_SMALL: "klein",
  BOARD_SIZE_MEDIUM: "mittel",
  BOARD_SIZE_BIG: "groß",

  BOARD_AXES_XY: "X & Y",
  BOARD_AXES_X: "nur X",
  BOARD_AXES_Y: "Nur Y",
  BOARD_AXES_NONE: "Keine",

  BOARD_TOOLTIP: `
  Erstellt eine Grafik entsprechend den gewählten oberen und unteren Grenzwerten, mit oder ohne Anzeige der Achsen und mit oder ohne Raster.
  Meist gefolgt von Blöcken Zeichnen, die verschiedene geometrische Elemente in den Graphen zeichnen.
  Kann in einem Block Größe (XL-S) enthalten sein, um die Darstellungsgröße des Diagramms zu ändern.
  `,
  //DRAW
  DRAW_MESSAGE: "Zeichnen %1", //Obsolete
  DRAW_IN_BOARD_MESSAGE: "zeichne %1 in Grafik%2",
  DRAW_TOOLTIP: `Zeichnet ein geometrisches Element.
  Enthält ein Geometrieelement, das in der ausgewählten Grafik gezeichnet werden soll.
  Zuvor muss eine Grafikvariable definiert werden.`,

  //ERASE IN BOARD
  ERASE_IN_BOARD_MESSAGE: "lösche %1 in der Grafik%2",
  ERASE_IN_BOARD_TOOLTIP: `Löscht ein geometrisches Element.
  Enthält die Variable des zu löschenden Geometrieelements in der ausgewählten Grafik.
  Zuvor müssen die Variable des Grafikelements und die Grafik definiert werden.`,

  //ERASE IN BOARD
  ERASE_ALL_BOARD_MESSAGE: "alle Elemente in der Grafik %1 löschen",
  ERASE_ALL_BOARD_TOOLTIP: `Löscht alle geometrischen Elemente eines Graphen.
  Enthält die Variable des zu löschenden Graphen.
  Zuvor muss die Variable des Graphen definiert werden.`,

  //BLOCK POLYGON
  POLYGON_MESSAGE: "Polygon mit den Eckpunkten %1",
  POLYGON_TOOLTIP: `Gibt ein Polygon mit n Eckpunkten zurück.
    Enthält eine Liste von Eckpunkten. Um eine Farbe zu definieren, schließen Sie sie in einen Farbblock ein.
    Meist in einem Block "Zeichnen" enthalten.`,

  //POINT
  POINT_MESSAGE: "Punkt %1 x%2 y%3 %4 %5 Optionen ",
  POINT_TOOLTIP_WITHLABEL: "den Punkt zeichnen",
  POINT_TOOLTIP_SHOWINFOBOX: "Koordinaten anzeigen",
  POINT_TOOLTIP_FIXED: "fest oder beweglich",
  POINT_TOOLTIP:
    "Gibt einen Punkt mit den Koordinaten x und y zurück. Optionen: siehe Dokumentation",
  POINT_DOCUMENTATION: `Gibt einen Punkt mit den Koordinaten x und y zurück.
  Optionen:
  - 🔵 : Zeichnet den Punkt.
  - 💬 : Zeigt die Koordinaten des Punktes beim Mouseover an.
  - 🔒 : Legt fest, ob der Punkt fixiert ist oder verschoben werden kann.
  - 🧲: Definiert die Attraktoren =>.
  - Ein Attraktor kann eine ganze Zahl sein: Der Punkt kann nur auf multiplen Abszissen und Ordinaten dieser Zahl positioniert werden.
  - Ein Attraktor kann eine Liste [a,b] sein: Der Punkt kann nur auf den vielfachen Abszissen von a und den vielfachen Ordinaten von b positioniert werden.
  - Ein Attraktor kann eine andere Figur sein: Der Punkt kann nur auf dem Umriss dieser Figur positioniert werden.`,

  //POINT COORDINATE
  FIGURE_COORDINATE_MESSAGE: "Koordinate %1 des in %2 gespeicherten Punktes",
  FIGURE_COORDINATE_TOOLTIP: `Gibt die x- oder y-Koordinate des Punktes zurück, der in einer Variablen gespeichert ist.
  Zuvor muss der Punkt in einer Variablen gespeichert werden.`,

  //LINE
  LINE_LINE: "rechts",
  LINE_SEGMENT: "Segment",
  LINE_ARROW: "Pfeil",
  LINE_DOTTED: "gepunktet",
  LINE_MESSAGE: "%1 geht durch%2 und%3",
  LINE_TOOLTIP: `Gibt eine Gerade, ein Segment oder einen Pfeil zurück, der durch zwei Punkte verläuft.`,
  //TANGENT
  TANGENT_MESSAGE: "Tangente geht durch %1",
  TANGENT_TOOLTIP: `Sendet eine Tangente, die durch einen Punkt mit einem oder mehreren Attraktoren definiert ist`,
  //CIRCLE
  CIRCLE_MESSAGE: "Kreis mit dem Mittelpunkt%1 und dem Radius%2",
  CIRCLE_TOOLTIP: `Gibt einen Kreis zurück, der durch einen Punkt definiert ist, der seinen Mittelpunkt und seinen Radius darstellt.`,
  //DISK - SECTOR - CIRCLE PORTION
  SECTOR_MESSAGE:
    "Kreissektor mit dem Mittelpunkt%1 und definiert durch den Punkt%2 und den Punkt%3",
  SECTOR_TOOLTIP:
    "Sendet ein Sektor wird durch drei Punkte definiert: Dem Mittelpunkt p1 des Sektors, einem zweiten Punkt p2, der den Radius definiert, und einem dritten Punkt p3, der den Winkel des Sektors definiert. Der Sektor wird immer gegen den Uhrzeigersinn von p2 nach p3 gezeichnet.",
  SECTOR_DOCUMENTATION: `Sendet ein Sektor wird durch drei Punkte definiert: Dem Mittelpunkt p1 des Sektors, einem zweiten Punkt p2, der den Radius definiert, und einem dritten Punkt p3, der den Winkel des Sektors definiert. Der Sektor wird immer gegen den Uhrzeigersinn von p2 nach p3 gezeichnet.
  Erweiterte Parameter (Anwenden des Blocks parametrisieren ... mit ...) :
      • "arcOnly": true / false
      • "hasFirstArrow": true / false
      • "hasLastArrow": true / false
  `,
  //BOARD_TEXT
  BOARD_TEXT_MESSAGE: "Text %1 positioniert auf %2",
  BOARD_TEXT_TOOLTIP:
    "Gibt einen Text zurück, der durch einen Text und seine Position durch einen Punkt definiert ist.",
  //BLOCK RANDOMPOLYGON
  RANDOMPOLYGON_MESSAGE: "🎲 zufälliges Polygon mit %1 Seiten",
  RANDOMPOLYGON_TOOLTIP: `Gibt ein Polygon mit n zufällig ausgewählten Eckpunkten zurück. Die Koordinaten der Eckpunkte werden aus einem Standarddiagramm ausgewählt.`,
  //BLOCK REGULARPOLYGON
  REGULARPOLYGON_MESSAGE:
    "regelmäßiges Vieleck mit Mittelpunkt%1, %2Seiten und Radius%3",
  REGULARPOLYGON_TOOLTIP: `Gibt ein regelmäßiges Polygon zurück, das durch seinen Mittelpunkt, die Anzahl der Seiten und den Radius definiert ist.`,

  //BLOCK RECTANGLE
  RECTANGLE_MESSAGE: "Rechteck mit der Länge %1 %2 und der Breite %3 %4",
  RECTANGLE_TOOLTIP:
    "Gibt ein Rechteck zurück, das durch seine Länge und Breite definiert und zufällig in einem Diagramm positioniert ist. Die Koordinaten der Eckpunkte werden aus einem Standarddiagramm ausgewählt.",
  //BLOCK FIGURE_PERIMETER
  FIGURE_PERIMETER_MESSAGE: "Umfang der Abbildung %1",
  FIGURE_PERIMETER_TOOLTIP: `Gibt den Umfang der Geometrischen Figur zurück.
  Enthält eine geometrische Figur (Rechteck, Polygon ...).`,
  //BLOCK FIGURE_AREA
  FIGURE_AREA_MESSAGE: "Fläche der Figur %1",
  FIGURE_AREA_TOOLTIP: `Gibt die Fläche der Geometrischen Figur zurück.
  Enthält eine geometrische Figur (Rechteck, Polygon, Kreis, ...).`,

  //BLOCK FIGURE_TRANSFORMS
  FIGURE_ROTATE_MESSAGE: "%1 von %2° drehen",
  FIGURE_ROTATE_TOOLTIP: `Drehen Sie die Figur um x Grad.`,
  FIGURE_TRANSLATE_MESSAGE: "Übersetzer %1 aus [%2,%3]",
  FIGURE_TRANSLATE_TOOLTIP: `Translatiert die Abbildung entlang des Vektors [x,y].`,
  FIGURE_SCALE_MESSAGE: "Skaliere %1 mit [%2,%3]",
  FIGURE_SCALE_TOOLTIP: `Skaliere die Abbildung entlang des Vektors [x,y].`,
  //BLOCK EUCLIDEAN_DISTANCE_TWOPOINTS
  EUCLIDEAN_DISTANCE_TWOPOINTS_MESSAGE: "Abstand zwischen %1 und %2",
  EUCLIDEAN_DISTANCE_TWOPOINTS_TOOLTIP: `Gibt die Entfernung zwischen zwei Punkten zurückk.
    Enthält zwei Punkte.`,
  //BLOCK EUCLIDEAN_DISTANCE
  EUCLIDEAN_DISTANCE_MESSAGE: "Abstand zwischen x1%1 y1%2 und x2%3 y2%4",
  EUCLIDEAN_DISTANCE_TOOLTIP: `Gibt die Entfernung zwischen zwei Punkten zurück.
  Enthält zwei Punkte.`,
  //BLOCK FIGURE_CLONE
  FIGURE_CLONE_MESSAGE: "Klon von %1",
  FIGURE_CLONE_TOOLTIP: `Gibt einen Klon einer geometrischen Figur zurück.
  Enthält eine geometrische Figur (Rechteck, Polygon, Kreis...).`,

  //MATH ALGEBRA
  //BLOCK RANDOMPOLYNOM
  RANDOMPOLYNOM_MESSAGE:
    "🎲 Zufallspolynom des Grades %1 mit den Koeffizienten %2",
  RANDOMPOLYNOM_TOOLTIP: `Gibt ein Zufallspolynom vom Typ Ausdruck zurück, das mit der Variablen 'x' ausgedrückt wird. Beispiel: x^2+2x-1.`,

  //BLOCK RANDOMPOLYNOM
  POLYNOM_WITH_COEFFICIENTS_MESSAGE: "Polynom mit den Koeffizienten %1",
  POLYNOM_WITH_COEFFICIENTS_TOOLTIP: `Gibt ein Polynom zurück, das durch eine Liste von Koeffizienten definiert ist.`,

  //BLOCK GRAPH_OF_FUNCTION
  GRAPH_OF_FUNCTION_MESSAGE: "Graph von f(x)= %1",
  GRAPH_OF_FUNCTION_TOOLTIP:
    "Gibt die grafische Darstellung der Funktion zurück, die durch einen Text oder einen Ausdruck definiert ist.",

  //BLOCK GRAPH_OF_FUNCTION_INTERVAL
  GRAPH_OF_FUNCTION_INTERVAL_MESSAGE: "Graph von f(x)= %1 auf [ %2 , %3 ]",
  GRAPH_OF_FUNCTION_INTERVAL_TOOLTIP:
    "Gibt die grafische Darstellung der durch einen Text oder einen Ausdruck definierten Funktion in einem Intervall zurück",

  //BLOCK AREA_UNDER_FUNCTION_INTERVAL
  AREA_UNDER_FUNCTION_INTERVAL_MESSAGE: "Fläche unter f(x)= %1 auf [ %2 , %3 ]",
  AREA_UNDER_FUNCTION_INTERVAL_TOOLTIP:
    "Gibt die grafische Darstellung der Fläche unter der Funktion zurück, die durch einen Text oder einen Ausdruck in einem Intervall definiert ist.",

  //BLOCK EXPRESSION
  EXPRESSION_MESSAGE: "Ausdruck %1",
  EXPRESSION_TOOLTIP:
    "Gibt einen durch Text definierten Ausdruck zurück (z. B.: 2*x+3)",
  //BLOCK DEGREE
  DEGREE_MESSAGE: "Grad des Polynoms %1 in Bezug auf %2",
  DEGREE_TOOLTIP:
    "Gibt den Grad eines Polynoms in Bezug auf die definierte Variable zurück.",
  //BLOCK COEFFICIENTS
  COEFFICIENTS_MESSAGE:
    "Liste der Koeffizienten des Polynoms %1 in Bezug auf %2",
  COEFFICIENTS_TOOLTIP:
    "Gibt die Liste der Koneffizienzen (vom kleinsten bis zum größten Grad) eines Polynoms in Bezug auf die definierte Variable zurück.",
  //PSEUDO BLOCK ADD POLYNOM
  COEFFICIENTS_OPERATOR_TOOLTIP:
    "Gibt ein neues Polynom zurück, das die Addition von zwei Polynomen ist. Funktioniert auch mit der Subtraktion",
  //BLOCK DERIVATIVE
  DERIVATIVE_MESSAGE: "Ableitung von %1 nach %2",
  DERIVATIVE_TOOLTIP:
    "Gibt die Ableitung eines Ausdrucks nach der definierten Variable zurück.",
  //PRIMITIVE
  PRIMITIVE_MESSAGE: "Primitiv von %1 in Bezug auf %2",
  PRIMITIVE_TOOLTIP:
    "Gibt das Primitiv eines Ausdrucks in Bezug auf die definierte Variable zurück.",
  //INTEGRAL
  INTEGRAL_MESSAGE: "Integral von %1 gegenüber %2 über [ %3 , %4 ]",
  INTEGRAL_TOOLTIP:
    "Gibt das Integral eines Ausdrucks über die Variable zurück, die auf einem Intervall definiert ist.",
  //BLOCK EVALUATE
  EVALUATE_MESSAGE: "Wert von %1 für %2=%3",
  EVALUATE_TOOLTIP:
    "Gibt die Bewertung des Ausdrucks zurück, wenn seine Variable gleich einem Wert ist.",
  //BLOCK SIMPLIFY
  SIMPLIFY_MESSAGE: "Vereinfachung von %1",
  SIMPLIFY_TOOLTIP: "Gibt die vereinfachte Form eines Ausdrucks zurück.",
  //BLOCK EXPAND
  EXPAND_MESSAGE: "Entwicklung von %1",
  EXPAND_TOOLTIP: "Gibt die expandierte Form eines Ausdrucks zurück.",
  //BLOCK UNIT
  UNIT_MESSAGE: "numerischer Wert %1 Einheit %2",
  UNIT_TOOLTIP:
    "Gibt ein Einheit-Objekt zurück, das angezeigt oder in eine andere Einheit umgewandelt werden kann.",
  UNIT_DOCUMENTATION: `Gibt ein Einheit-Objekt zurück, das angezeigt oder in eine andere Einheit umgerechnet werden kann.
    Liste der akzeptierten Einheiten:
- Length 	meter (m), inch (in), foot (ft), yard (yd), mile (mi), link (li), rod (rd), chain (ch), angstrom, mil
- Surface area 	m2, sqin, sqft, sqyd, sqmi, sqrd, sqch, sqmil, acre, hectare
- Volume 	m3, litre (l, L, lt, liter), cc, cuin, cuft, cuyd, teaspoon, tablespoon
- Liquid volume 	minim, fluiddram (fldr), fluidounce (floz), gill (gi), cup (cp), pint (pt), quart (qt), gallon (gal), beerbarrel (bbl), oilbarrel (obl), hogshead, drop (gtt)
- Angles 	rad (radian), deg (degree), grad (gradian), cycle, arcsec (arcsecond), arcmin (arcminute)
- Time 	second (s, secs, seconds), minute (min, mins, minutes), hour (h, hr, hrs, hours), day (days), week (weeks), month (months), year (years), decade (decades), century (centuries), millennium (millennia)
- Frequency 	hertz (Hz)
- Mass 	gram(g), tonne, ton, grain (gr), dram (dr), ounce (oz), poundmass (lbm, lb, lbs), hundredweight (cwt), stick, stone
- Electric current 	ampere (A)
- Temperature 	kelvin (K), celsius (degC), fahrenheit (degF), rankine (degR)
- Amount of substance 	mole (mol)
- Luminous intensity 	candela (cd)
- Force 	newton (N), dyne (dyn), poundforce (lbf), kip
- Energy 	joule (J), erg, Wh, BTU, electronvolt (eV)
- Power 	watt (W), hp
- Pressure 	Pa, psi, atm, torr, bar, mmHg, mmH2O, cmH2O
- Electricity and magnetism 	ampere (A), coulomb (C), watt (W), volt (V), ohm, farad (F), weber (Wb), tesla (T), henry (H), siemens (S), electronvolt (eV)
- Binary 	bits (b), bytes (B)`,
  //BLOCK CONVERT_INTO_UNIT
  CONVERT_INTO_UNIT_MESSAGE: "Umwandlung von %1 in %2",
  CONVERT_INTO_UNIT_TOOLTIP:
    "Gibt den Wert des Ausdrucks zurück, der in die neue Einheit umgewandelt wurde.",
  ///////////////////////////////////
  //BLOCKS FRACTION
  FRACTION_MESSAGE: "Bruch %1 / %2",
  FRACTION_TOOLTIP:
    "Gibt einen Bruch zurück, der durch seinen Zähler und Nenner definiert ist.",

  CONVERT_INTO_FRACTION_MESSAGE: "Umwandlung von %1 in einen Bruchteil",
  CONVERT_INTO_FRACTION_TOOLTIP: "Gibt eine Zahl als Bruch zurück.",

  FRACTION_NUMERATOR_DENOMINATOR_MESSAGE: "%1 von %2",
  FRACTION_NUMERATOR_DENOMINATOR_NUMERATOR: "Zähler",
  FRACTION_NUMERATOR_DENOMINATOR_DENOMINATOR: "Nenner",
  FRACTION_NUMERATOR_DENOMINATOR_TOOLTIP:
    "Gibt den Zähler oder den Nenner eines Bruchs zurück.",

  SIMPLIFY_FRACTION_MESSAGE: "irreduzibler Bruch von %1",
  SIMPLIFY_FRACTION_TOOLTIP:
    "Gibt einen Bruch in seiner irreduziblen Form zurück.",

  //MATH MATRIX
  //TABLE_DATA
  DATA_TABLE_TITLE: "Datentabelle",
  DATA_TABLE_TOOLTIP:
    "Gibt ein Array im Matrixformat zurück, das aus den definierten Werten gebildet wird",

  //NUMPRY MATRIX (disable)
  NUMPY_SQUARE_MATRIX_TITLE: "Matrix",
  MATRIX_TABLE_TOOLTIP:
    "Gibt eine Matrix zurück, die aus den definierten Werten gebildet wird",
  //MATRIX
  MATRIX_MESSAGE: "eine Matrix mit %1 %2 erstellen",
  MATRIX_TOOLTIP:
    "Gibt eine Matrix zurück, die aus dem Text [[1,2],[3,4]] oder aus einer bereits definierten Liste konstruiert wurde.",
  //MATRIX3PARAMS (MATRIX_RANDOM)
  MATRIX3PARAMS_MESSAGE:
    "eine Matrix aus %1 Zeilen und %2 Spalten erstellen, die mit %3 gefüllt ist",
  MATRIX3PARAMS_TOOLTIP: `Gibt eine Matrix der definierten Größe zurück, die mit einem bestimmten Wert oder dem Ergebnis einer Berechnung gefüllt ist.`,
  //MATRIXDETERMINANT
  MATRIXDETERMINANT_MESSAGE: "Determinante der Matrix %1",
  MATRIXDETERMINANT_TOOLTIP: "Gibt die Determinante der Matrix zurück.",
  //MATRIX_SUM
  MATRIX_SUM_MESSAGE: "Summe aus Matrix %1 und Matrix %2",
  MATRIX_SUM_TOOLTIP: "Gibt die Addition der beiden Matrizen zurück.",
  //MATRIX_MULTIPLICATION
  MATRIX_MULTIPLICATION_MESSAGE:
    "Matrixprodukt der Matrix %1 mit der Matrix %2",
  MATRIX_MULTIPLICATION_TOOLTIP:
    "Gibt das Matrixprodukt von zwei Matrizen zurück.",
  //MATRIX_SCALAR
  MATRIX_SCALAR_MESSAGE: "Produkt(skalar) der Zahl %1 und der Matrix %2",
  MATRIX_SCALAR_TOOLTIP:
    "Gibt das Produkt zwischen einem Skalar und einer Matrix zurück.",
  //MATRIX_SHORT_SET
  MATRIX_SHORT_SET_MESSAGE: "%1[%2,%3]=%4",
  MATRIX_SHORT_SET_TOOLTIP: "Setzt das Element einer Matrix auf den Index i,j",
  //MATRIX_SHORT_GET
  MATRIX_SHORT_GET_MESSAGE: "%1[%2,%3]",
  MATRIX_SHORT_GET_TOOLTIP: "Gibt das Element einer Matrix an Index i,j zurück",
  //////////////////LISTS
  //RANDOMLIST
  RANDOMLIST_MESSAGE: "eine Liste mit der Länge %1 erstellen und mit %2 füllen",
  RANDOMLIST_TOOLTIP: `Gibt eine Liste mit der definierten Größe zurück, die mit einem bestimmten Wert oder dem Ergebnis einer Berechnung gefüllt ist.`,
  //LISTSSHUFFLE
  SHUFFLELIST_MESSAGE:
    "🎲 Mische die Elemente in der Liste %1 nach dem Zufallsprinzip",
  SHUFFLELIST_TOOLTIP:
    "Enthält die Liste, in der die Elemente gemischt werden.",
  //BLOCK DELETE_DUPLICATE
  DELETE_DUPLICATES_MESSAGE: "Duplikate in der Liste %1 löschen",
  DELETE_DUPLICATES_TOOLTIP: "Entfernt doppelte Einträge in der Liste",
  //BLOCK DELETE_ELEMENT_FROM_LIST
  DELETE_ELEMENT_FROM_LIST_MESSAGE: "Element %1 aus der Liste %2 entfernen",
  DELETE_ELEMENT_FROM_LIST_TOOLTIP: "Ein Element aus einer Liste löschen",
  //BLOCK COUNT_SAME_ELEMENT_LIST
  COUNT_SAME_ELEMENT_LIST_MESSAGE:
    "zählt die Anzahl der Vorkommen von %1 in der Liste %2",
  COUNT_SAME_ELEMENT_LIST_TOOLTIP:
    "Gibt die Anzahl der Vorkommen eines Elements in einer Liste zurück.",
  //LIST_SHORT_SET
  LIST_SHORT_SET_MESSAGE: "%1[%2]=%3",
  LIST_SHORT_SET_TOOLTIP: "Setzt das Element einer Liste auf den Index i.",
  //LIST_SHORT_GET
  LIST_SHORT_GET_MESSAGE: "%1[%2]",
  LIST_SHORT_GET_TOOLTIP: "Gibt das Element einer Liste an Index i zurück.",

  //CATMEDIA
  //BLOCK ELEDA_IMAGE
  IMAGE_MESSAGE: "🏞 image %1 URL %2 legende %3 %4optionen",
  IMAGE_WIDTH: "Breite",
  IMAGE_HEIGHT: "Höhe",
  IMAGE_TOOLTIP: `Zeigt ein Bild mithilfe eines Links an.
    - URL: Sie enthält die Adresse oder den Link des Bildes.`,

  IMAGE_DOCUMENTATION: `Zeigt ein Bild mithilfe eines Links an.
    - URL: Sie enthält die Adresse oder den Link des Bildes.
  
    Optionen :
    - Breite: Legt eine feste Breite für das Bild fest.
    - Höhe: Legt eine feste Höhe für das Bild fest.`,

  //BLOCK ELEDA_VIDEO
  VIDEO_MESSAGE: "📽 video %1 Integrationscode %2 legende %3",
  VIDEO_TOOLTIP: `Zeigt ein Video mithilfe eines Einbettungscodes an.
    - Einbettungscode: Enthält den Einbettungscode für das Video (Rechtsklick auf ein Video, dann Einbettungscode kopieren).`,

  //BLOCK ELEDA AUDIO
  ELEDA_AUDIO_MESSAGE:
    "♬ Audio %1 Anzahl der Wiederholungen %2 Link (mp3, mp4...) %3 legende %4",

  //BLOCK TABLE (HTML) MATRIX
  TABLE_MATRIX_TITLE: "Gemälde",
  GRID_MATRIX_TITLE: "Gitter",
  TABLE_MATRIX_TOOLTIP:
    "Aus den eingegebenen Elementen eine HTML-Tabelle erstellen",

  //BLOCK TABLE (HTML) COLUMN
  TABLE_COLUMN_TITLE: "Spalte(n)",
  TABLE_COLUMN_TOOLTIP:
    "Erstellen Sie eine Spalte, die Zellen für die Tabelle generiert",

  TEXT_JOIN_TITLE: "Text erstellen mit",
  TEXT_JOIN_HELPURL: "",
  TEXT_JOIN_TOOLTIP: "",

  //block eleda_alignment
  ELEDA_ALIGNMENT_TEXT: "Ausrichtung",

  //CLONE
  CLONE_MESSAGE: "Klon von %1",

  //Backpack
  EMPTY_BACKPACK: "Leer",
  REMOVE_FROM_BACKPACK: "Aus dem Rucksack entfernen",
  COPY_TO_BACKPACK: "In den Rucksack kopieren",
  COPY_ALL_TO_BACKPACK: "Alle Blöcke in den Rucksack kopieren",
  PASTE_ALL_FROM_BACKPACK: "Alle Blöcke in die Arbeitsfläche einfügen",

  //TEXT_CHANGECASE
  TEXT_CHANGECASE_OPERATOR_FIRSTLETTERCASE:
    "in Anfangskapitale für das erste Wort",

  //Dictionary
  DICTIONARY_TITLE: "Wörterbuch",
  DICTIONARY_MESSAGE: "Wörterbuch %1 %2",
  DICTIONARY_HELPURL: "",
  DICTIONARY_TOOLTIP: "",

  //random_verb
  RANDOM_VERB_TITLE: "Verbe Aléatoire",
  RANDOM_VERB_MESSAGE: "🎲 Zufallsverb aus dem Wörterbuch %1 %2 der %3 Gruppe",
  RANDOM_VERB_HELPURL: "",
  RANDOM_VERB_TOOLTIP: "",

  //selected verb
  SELECTED_VERB_TITLE: "Verben",
  SELECTED_VERB_MESSAGE:
    "Verb aus dem Wörterbuch %1 %2 %3 mit dem Infinitiv %4",
  SELECTED_VERB_HELPURL: "",
  SELECTED_VERB_TOOLTIP: "",

  //verb_getAttribute
  VERB_GETATTRIBUTE_TITLE: "Das Attribut eines Verbs erhalten",
  VERB_GETATTRIBUTE_MESSAGE: "die %1 des Verbs %2 erhalten",
  VERB_GETATTRIBUTE_HELPURL: "",
  VERB_GETATTRIBUTE_TOOLTIP: "",

  //conjugate_verb
  CONJUGATE_VERB_TITLE: "Erhalten Sie die Konjugationen eines Verbs",
  CONJUGATE_VERB_MESSAGE:
    "die Konjugationen des Verbs %1 mit %2 aus dem Wörterbuch %3 abrufen",
  CONJUGATE_VERB_HELPURL: "",
  CONJUGATE_VERB_TOOLTIP: "",

  //selected_determinantDefInfDemons
  SELECTED_DETERMINANTDEFINFFEMONS_TITLE: "Determinant in/definite of a name",
  SELECTED_DETERMINANTDEFINFFEMONS_MESSAGE:
    "determinant of dictionary %1 %2 of type %3 for name %4",
  SELECTED_DETERMINANTDEFINFFEMONS_HELPURL: "",
  SELECTED_DETERMINANTDEFINFFEMONS_TOOLTIP: "",

  //determinantDefInfDemons_getAttribute
  DETERMINANTDEFINFDEMONS_GETATTRIBUTE_TITLE:
    "Ein Attribut von einem Determinanten erhalten",
  DETERMINANTDEFINFDEMONS_GETATTRIBUTE_MESSAGE:
    "das %1 des (un)bestimmten oder demonstrativen Bestimmungswortes %2 erhalten",
  DETERMINANTDEFINFDEMONS_GETATTRIBUTE_HELPURL: "",
  DETERMINANTDEFINFDEMONS_GETATTRIBUTE_TOOLTIP: "",

  //selected_determinantPoss
  SELECTED_DETERMINANTPOSS_TITLE: "Possessive determinant of a name",
  SELECTED_DETERMINANTPOSS_MESSAGE:
    "determinant possessivum aus dem Wörterbuch %1 %2 für den Namen %3",
  SELECTED_DETERMINANTPOSS_HELPURL: "",
  SELECTED_DETERMINANTPOSS_TOOLTIP: "",

  //determinantPoss_getListForNumber
  DETERMINANTPOSS_GETLISTFORNUMBER_TITLE: "Liste der possessiven Determinanten",
  DETERMINANTPOSS_GETLISTFORNUMBER_MESSAGE:
    "die Liste auf %1 des possessiven Bestimmungswortes %2 erhalten",
  DETERMINANTPOSS_GETLISTFORNUMBER_HELPURL: "",
  DETERMINANTPOSS_GETLISTFORNUMBER_TOOLTIP: "",

  //random_name
  RANDOM_NAME_TITLE: "Zufälliger Name",
  RANDOM_NAME_MESSAGE:
    "🎲 zufälliger Name aus dem Wörterbuch %1 %2 mit dem Geschlecht %3",
  RANDOM_NAME_HELPURL: "",
  RANDOM_NAME_TOOLTIP: "",

  //selected_name
  SELECTED_NAME_TITLE: "Name",
  SELECTED_NAME_MESSAGE: "Name des Wörterbuchs %1 %2 mit dem Titel %3",
  SELECTED_NAME_HELPURL: "",
  SELECTED_NAME_TOOLTIP: "",

  //name_getAttribute
  NAME_GETATTRIBUTE_TITLE: "Attribut eines Namens erhalten",
  NAME_GETATTRIBUTE_MESSAGE: "den %1 des Namens %2 erhalten",
  NAME_GETATTRIBUTE_HELPURL: "",
  NAME_GETATTRIBUTE_TOOLTIP: "",

  //random_adjective
  RANDOM_ADJECTIVE_TITLE: "Zufallsadjektiv",
  RANDOM_ADJECTIVE_MESSAGE: "🎲 Zufallsadjektiv aus dem Wörterbuch %1",
  RANDOM_ADJECTIVE_HELPURL: "",
  RANDOM_ADJECTIVE_TOOLTIP: "",

  //selected_adjective
  SELECTED_ADJECTIVE_TITLE: "Adjektiv",
  SELECTED_ADJECTIVE_MESSAGE:
    "Adjektiv im Wörterbuch %1 %2 mit der Überschrift %3",
  SELECTED_ADJECTIVE_HELPURL: "",
  SELECTED_ADJECTIVE_TOOLTIP: "",

  //adjective_getAttribute
  ADJECTIVE_GETATTRIBUTE_TITLE: "Das Attribut eines Adjektivs erhalten",
  ADJECTIVE_GETATTRIBUTE_MESSAGE: "das %1 des Adjektivs %2 erhalten",
  ADJECTIVE_GETATTRIBUTE_HELPURL: "",
  ADJECTIVE_GETATTRIBUTE_TOOLTIP: "",

  //split_into_words_letters
  SPLIT_INTO_WORDS_LETTERS_TITLE: "Text ausschneiden",
  SPLIT_INTO_WORDS_LETTERS_MESSAGE: "den Text %1 %2 in %3 zerlegen",
  SPLIT_INTO_WORDS_LETTERS_HELPURL: "",
  SPLIT_INTO_WORDS_LETTERS_TOOLTIP: "",

  //french words
  MALE: "männlich",
  FEMALE: "feminin",
  SINGULAR: "singulär",
  PLURAL: "Plural",
  RANDOM: "zufällig",
  GENDER: "Gender",
  NUMBER: "Anzahl",
  WORDS: "Wörter",
  LETTERS: "Briefe",

  //LOGIC CATEGORY (ADD DOC TO BLOCKLY EXISTING BLOCKS)
  LOGIC_COMPARE_DOCUMENTATION:
    "Gibt true zurück, wenn beide Eingaben gleich sind. = und ≠ können auch zum Vergleich geometrischer Objekte verwendet werden.",
};
